import { Skeleton } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { RouteIcon } from './icons';

/**
 * Skeleton exibido enquanto o `GET /jobs/:id` está em voo na primeira
 * carga da subseção Áreas de atuação (EU-159 FR-067a). Mantém o layout
 * (header + área de upload + alert do gabarito + rodapé) para evitar shift
 * de paint quando os dados chegam.
 */
export function JobEditWorkAreasLoadingFallback() {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu activeId="jobs" />

      <main className="flex flex-1 flex-col items-center gap-8 bg-card px-4 pt-8 pb-16 md:px-8">
        <div
          aria-busy="true"
          aria-label="Carregando seção de vagas"
          data-testid="job-edit-work-areas-loading"
          className="flex w-full max-w-[630px] flex-col gap-8"
        >
          <header className="flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="flex size-8 items-center justify-center rounded-md bg-secondary text-secondary-foreground">
                <RouteIcon className="size-4" />
              </div>
              <Skeleton className="h-9 w-64" />
            </div>
            <Skeleton className="h-6 w-24" />
          </header>

          <div className="flex flex-col gap-5">
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-20 w-full" />
          </div>
        </div>
      </main>
    </div>
  );
}
